/** A typed amount (commas and spaces ignored), or null. */
export function parseAmount(value: string): number | null {
  const trimmed = value.replace(/\s/g, "");
  // Commas only as thousands groups: a comma-decimal "12,5" must not read as 125.
  if (!/^(\d{1,3}(,\d{3})+|\d+)(\.\d+)?$/.test(trimmed)) return null;
  const v = trimmed.replace(/,/g, "");
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}
